var exports = {
  "wrapper": "xaee3c4fa--353d40--wrapper",
  "_top": "xaee3c4fa--353d40--_top",
};

module.exports = exports;
